import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PasswordRecoveryState {
  otp: string;
  email: string;
  isSubmitting: boolean;
  errorMessage: string | null;
  successMessage: string;
  showErrorModal: boolean;
  successModal: boolean;
  resendMessage: string | null;
  isResending: boolean;
  resendModal: boolean;
  storedEmail: string;

  // Actions
  setOtp: (otp: string) => void;
  setEmail: (email: string) => void;
  setIsSubmitting: (isSubmitting: boolean) => void;
  setErrorMessage: (errorMessage: string | null) => void;
  setSuccessMessage: (successMessage: string) => void;
  setShowErrorModal: (showErrorModal: boolean) => void;
  setSuccessModal: (successModal: boolean) => void;
  setResendMessage: (resendMessage: string | null) => void;
  setIsResending: (isResending: boolean) => void;
  setResendModal: (resendModal: boolean) => void;
  setStoredEmail: (storedEmail: string) => void;
  reset: () => void;
}

const usePasswordRecoveryStore = create<PasswordRecoveryState>()(
  persist(
    (set) => ({
      otp: '',
      email: '',
      isSubmitting: false,
      errorMessage: null,
      successMessage: '',
      showErrorModal: false,
      successModal: false,
      resendMessage: null,
      isResending: false,
      resendModal: false,
      storedEmail: '',

      // Actions
      setOtp: (otp) => set({ otp }),
      setEmail: (email) => set({ email }),
      setIsSubmitting: (isSubmitting) => set({ isSubmitting }),
      setErrorMessage: (errorMessage) => set({ errorMessage }),
      setSuccessMessage: (successMessage) => set({ successMessage }),
      setShowErrorModal: (showErrorModal) => set({ showErrorModal }),
      setSuccessModal: (successModal) => set({ successModal }),
      setResendMessage: (resendMessage) => set({ resendMessage }),
      setIsResending: (isResending) => set({ isResending }),
      setResendModal: (resendModal) => set({ resendModal }),
      setStoredEmail: (storedEmail) => set({ storedEmail }),
      reset: () => set({ 
        otp: '',
        isSubmitting: false,
        errorMessage: null,
        successMessage: '',
        showErrorModal: false,
        successModal: false,
        resendMessage: null,
        isResending: false,
        resendModal: false,
      }),
    }),
    {
      name: 'password-recovery-storage',
      partialize: (state) => ({
        email: state.email,
        storedEmail: state.storedEmail,
      }),
    }
  )
);

export default usePasswordRecoveryStore;
